import { signOut as signOutAuth } from "aws-amplify/auth";
import { clearAuthFlowCookie } from "utils/authFlowCookie";

import { resetPosthog } from "../instrumentation/posthog";

/**
 * Clear Amplify/Oak session the same way TopNav Sign out does.
 * Always ends with a full navigation so SPA state cannot linger.
 *
 * Amplify must already be configured (`providers/auth` is imported from main.tsx).
 */
export async function performOakSignOut(options?: { redirectTo?: string }): Promise<void> {
  localStorage.setItem("logout", "true");
  // Clear PostHog identity + session keys so the next user on a shared browser
  // isn't merged into this user's analytics profile.
  resetPosthog();
  clearAuthFlowCookie();
  try {
    await signOutAuth();
  } catch (err) {
    console.error("Error during signout:", err);
  }
  window.location.href = options?.redirectTo ?? "/";
}
